module.exports = __webpack_public_path__ + "img/sustainable_buildings.2f979433.svg";